module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_vestland_neg.dc34c03f.png";